import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchPurchases } from '../store/paymentSlice';
import ContentGrid from '../components/ContentGrid';

export default function Library() {
  const dispatch = useDispatch();
  const { purchases } = useSelector((state) => state.payment);

  useEffect(() => {
    dispatch(fetchPurchases());
  }, [dispatch]);

  return (
    <div className="category-page">
      <h2 className="category-title">My Library</h2>
      {purchases.length === 0 ? (
        <p className="empty">You haven't purchased any content yet.</p>
      ) : (
        <ContentGrid items={purchases} loading={false} />
      )}
    </div>
  );
}
